import Decimal from 'decimal.js';
import { serviceModel } from "../../../../models";
import { getRelevantPeriod } from "./BillServiceModal.utils";
import compact from 'lodash/compact';
import { utils } from "../../../../utils";
export function getTableDefs(service) {
  const isVariablePrice = serviceModel.isVariablePrice(service.cost);
  const isRangePrice = serviceModel.isRangePrice(service.cost);
  const discount = serviceModel.discount(service);
  const isPercentDiscount = discount == null || discount.isPercent();
  const tableDefs = compact([{
    headerItem: {
      value: 'Service name'
    },
    columnDef: {
      width: 230
    }
  }, isVariablePrice && {
    headerItem: {
      value: 'Quantity'
    },
    columnDef: {
      width: 90
    }
  }, (isRangePrice || isVariablePrice) && {
    headerItem: {
      value: 'Preapproved'
    },
    columnDef: {
      width: isVariablePrice ? 90 : 130
    }
  }, {
    headerItem: {
      value: 'Rate'
    },
    columnDef: {
      width: 140
    }
  }, {
    headerItem: {
      value: isPercentDiscount ? 'Discount' : 'Unit discount'
    },
    columnDef: {
      width: 90
    }
  }, {
    headerItem: {
      value: 'Total'
    },
    columnDef: {
      width: [160, 250]
    }
  }]);
  return {
    columnDefs: tableDefs.map(d => d.columnDef),
    headerItems: tableDefs.map(d => d.headerItem)
  };
}
export let QtyWarning = /*#__PURE__*/function (QtyWarning) {
  QtyWarning["Billed"] = "billed";
  QtyWarning["Scheduled"] = "scheduled";
  return QtyWarning;
}({});
export const qtyWarningToText = {
  billed: 'Exceeding the preapproved amount will require your client to manually approve the payment',
  scheduled: "Amount exceeds the preapproved quantity due to a scheduled bill and requires client's approval."
};
export function getQuantityWarning(service, quantity, issueDate, manualServiceBilling) {
  const unitCap = serviceModel.unitCap(service);
  if (serviceModel.isVariablePrice(service.cost) && unitCap != null) {
    const relevantPeriod = issueDate && getRelevantPeriod(manualServiceBilling, issueDate);
    const {
      billedQuantity = new Decimal(0),
      scheduledQuantity = new Decimal(0)
    } = relevantPeriod || {};
    if (quantity.plus(billedQuantity).gt(unitCap)) {
      return QtyWarning.Billed;
    }
    if (quantity.plus(billedQuantity).plus(scheduledQuantity).gt(unitCap)) {
      return QtyWarning.Scheduled;
    }
  }
  return null;
}
export function getTotal(service, quantity, priceInput) {
  let total = new Decimal(0);
  if (serviceModel.isRangePrice(service.cost)) {
    total = priceInput ? utils.applyDiscount(+priceInput, serviceModel.discount(service)) : new Decimal(0);
  } else {
    total = serviceModel.finalPrice(service, quantity);
  }
  return Decimal.max(total, 0);
}